import React from 'react';
import { useTranslation } from 'react-i18next';

export const GoalTasksTableHeader: React.FC = () => {
  const { t } = useTranslation('oneOnOne');

  return (
    <div className="bg-gray-50 border-b border-gray-200 px-4 py-2.5">
      <div className="grid grid-cols-12 gap-3 items-center text-xs font-medium text-gray-600">
        <div className="col-span-2 text-center">{t('tasksTable.status')}</div>
        <div className="col-span-4">{t('tasksTable.task')}</div>
        <div className="col-span-2 text-center">
          {t('tasksTable.assignees')}
        </div>
        <div className="col-span-2 text-center">
          {t('tasksTable.startDate')}
        </div>
        <div className="col-span-2 text-center">{t('tasksTable.dueDate')}</div>
      </div>
    </div>
  );
};
